import gql from 'graphql-tag';

export default gql`
  query GetGroupAttributes {
    groupAttributes {
      id
      description
      value
    }
  }
`;



// WEBPACK FOOTER //
// ./src/@data/withGroupAttributes/groupAttributesQuery.js